/**
 * Enum representing the state of a bar relative to a price level
 */
export var BarLevelState;
(function (BarLevelState) {
    BarLevelState["above"] = "above";
    BarLevelState["below"] = "below";
    BarLevelState["crossing"] = "crossing";
    BarLevelState["rejectedAbove"] = "rejectedAbove";
    BarLevelState["rejectedBelow"] = "rejectedBelow";
    BarLevelState["touchingFromAbove"] = "touchingFromAbove";
    BarLevelState["touchingFromBelow"] = "touchingFromBelow"; // Bar's high touches the level from below
})(BarLevelState || (BarLevelState = {}));
/**
 * Enum representing events that can occur at a price level
 */
export var LevelEventType;
(function (LevelEventType) {
    LevelEventType["supportToResistance"] = "supportToResistance";
    LevelEventType["resistanceToSupport"] = "resistanceToSupport";
    LevelEventType["directSupport"] = "directSupport";
    LevelEventType["directResistance"] = "directResistance";
    LevelEventType["directSupportLoose"] = "directSupportLoose";
    LevelEventType["directResistanceLoose"] = "directResistanceLoose";
    LevelEventType["levelCloseBreakout"] = "levelCloseBreakout";
    LevelEventType["levelCloseBreakdown"] = "levelCloseBreakdown";
    LevelEventType["levelFullCandleBreakout"] = "levelFullCandleBreakout";
    LevelEventType["levelFullCandleBreakdown"] = "levelFullCandleBreakdown";
    LevelEventType["breakoutAndRetest"] = "breakoutAndRetest";
    LevelEventType["breakdownAndRetest"] = "breakdownAndRetest"; // Bar closes below level and breaks down, then retests the level
})(LevelEventType || (LevelEventType = {}));
/**
 * Enum representing the role a level is playing
 */
export var LevelRole;
(function (LevelRole) {
    LevelRole["support"] = "support";
    LevelRole["resistance"] = "resistance";
    LevelRole["neutral"] = "neutral";
    LevelRole["potentialBreakout"] = "potentialBreakout";
    LevelRole["potentialBreakdown"] = "potentialBreakdown"; // Level might be breaking down (support to resistance)
})(LevelRole || (LevelRole = {}));
/**
 * Direction of price movement relative to a level
 */
export var PriceLevelDirection;
(function (PriceLevelDirection) {
    PriceLevelDirection["towardsLevel"] = "towardsLevel";
    PriceLevelDirection["awayFromLevel"] = "awayFromLevel";
    PriceLevelDirection["parallelToLevel"] = "parallelToLevel";
    PriceLevelDirection["undetermined"] = "undetermined"; // Not enough data or movement to determine
})(PriceLevelDirection || (PriceLevelDirection = {}));
//# sourceMappingURL=LevelAnalyzer.js.map